import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

export interface PublicLimitAPICallData {
    public_id: string;
    limit: number;
}

export class PublicLimitAPICall extends APICallV4<PublicLimitAPICallData> {
    _method = 'public/limit/set';
    _type: Method = 'post';
    _retriesCount = 0;
}
